<template>
  <header id="header" class="c-header" :style="{ backgroundImage: 'url(' + image + ')' }">
    <h1><slot/></h1>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    image: {
      type: String,
      default: '/img/header_bg.png'
    }
  }
}
</script>
